export default __webpack_public_path__ + "assets/images/f0c93dd96e06085a415a2d056877f732.svg";